/* REAPER Custom Theme - Global JS v2 */
'use strict';

// ---- Mobile Menu ----
const hamburger   = document.getElementById('hamburger-btn');
const mobileMenu  = document.getElementById('mobile-menu');
const mmOverlay   = document.getElementById('mm-overlay');
const mmCloseBtn  = document.getElementById('mm-close-btn');

function openMenu() {
  hamburger.classList.add('open');
  hamburger.setAttribute('aria-expanded', 'true');
  mobileMenu.classList.add('open');
  mobileMenu.setAttribute('aria-hidden', 'false');
  mmOverlay.classList.add('active');
  document.body.classList.add('menu-open');
  // focus first link for a11y
  const firstLink = mobileMenu.querySelector('.mm-link, a');
  if (firstLink) setTimeout(() => firstLink.focus(), 350);
}

function closeMenu() {
  hamburger.classList.remove('open');
  hamburger.setAttribute('aria-expanded', 'false');
  mobileMenu.classList.remove('open');
  mobileMenu.setAttribute('aria-hidden', 'true');
  mmOverlay.classList.remove('active');
  document.body.classList.remove('menu-open');
  hamburger.focus();
}

if (hamburger) hamburger.addEventListener('click', () => {
  mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
});

if (mmCloseBtn) mmCloseBtn.addEventListener('click', closeMenu);
if (mmOverlay)  mmOverlay.addEventListener('click', closeMenu);

// Close on Escape key
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('open')) closeMenu();
});

// ---- Accordion sub-menus ----
document.querySelectorAll('.mm-accordion').forEach((trigger) => {
  trigger.addEventListener('click', () => {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    // close all other open accordions
    document.querySelectorAll('.mm-accordion[aria-expanded="true"]').forEach((other) => {
      if (other !== trigger) {
        other.setAttribute('aria-expanded', 'false');
        const otherSub = other.nextElementSibling;
        if (otherSub) otherSub.classList.remove('open');
      }
    });
    // toggle this one
    trigger.setAttribute('aria-expanded', String(!isExpanded));
    const subList = trigger.nextElementSibling;
    if (subList) subList.classList.toggle('open', !isExpanded);
  });
});

// ---- Cart Count Update ----
function updateCartCount(count) {
  const el = document.getElementById('cart-count');
  if (!el) return;
  el.textContent = count;
  el.classList.toggle('hidden', count === 0);
}

// ---- Cart Overlay ----
const cartOverlay = document.getElementById('cart-overlay');
if (cartOverlay) {
  cartOverlay.addEventListener('click', () => {
    cartOverlay.classList.remove('active');
    document.body.classList.remove('cart-open');
  });
}

console.log('[REAPER] Theme v2 loaded');
